// Standard base64 for bytes, both ways. The player report and the report
// outbox write a screenshot through it, and the push subscription reads
// the VAPID key through it. The module imports nothing.

/** Writes bytes as standard base64, in chunks, so a large image does not
 *  pass one argument list of a call. */
export function base64Of(bytes: Uint8Array): string {
  let bin = '';
  for (let i = 0; i < bytes.length; i += 0x8000) {
    bin += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  }
  return btoa(bin);
}

/** The bytes of standard base64. `atob` throws on a string that is no
 *  base64. */
export function bytesOfBase64(s: string): Uint8Array {
  const bin = atob(s);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
